// @flow

import * as React from 'react';
import classnames from 'classnames';
import { ReactComponent as Ban } from './img/ban.svg';
import { ReactComponent as Bell } from './img/bell.svg';
import { ReactComponent as Receipt } from './img/receipt.svg';
import { ReactComponent as Carret } from './img/carret.svg';
import { ReactComponent as ChevronBack } from './img/chevron-back.svg';
import { ReactComponent as ChevronNext } from './img/chevron-next.svg';
import { ReactComponent as Clipboard } from './img/clipboard.svg';
import { ReactComponent as Cloudupload } from './img/cloudupload.svg';
import { ReactComponent as Document } from './img/document.svg';
import { ReactComponent as EllipsisVertical } from './img/ellipsis-vertical.svg';
import { ReactComponent as Exit } from './img/exit.svg';
import { ReactComponent as Home } from './img/home.svg';
import { ReactComponent as List } from './img/list.svg';
import { ReactComponent as Menu } from './img/menu.svg';
import { ReactComponent as Pencil } from './img/pencil.svg';
import { ReactComponent as Phone } from './img/phone.svg';
import { ReactComponent as Play } from './img/play.svg';
import { ReactComponent as Plus } from './img/plus.svg';
import { ReactComponent as Search } from './img/search.svg';
import { ReactComponent as Star } from './img/star.svg';
import { ReactComponent as Times } from './img/times.svg';
import { ReactComponent as Tools } from './img/tools.svg';
import { ReactComponent as User } from './img/user.svg';

const ICONS_MAP = {
    ban         : Ban,
    bell        : Bell,
    carret      : Carret,
    chevronback : ChevronBack,
    chevronnext : ChevronNext,
    clipboard   : Clipboard,
    cloudupload : Cloudupload,
    document    : Document,
    ellipsisv   : EllipsisVertical,
    receipt     : Receipt,
    exit        : Exit,
    home        : Home,
    list        : List,
    menu        : Menu,
    pencil      : Pencil,
    phone       : Phone,
    play        : Play,
    plus        : Plus,
    search      : Search,
    star        : Star,
    times       : Times,
    tools       : Tools,
    user        : User
};

// eslint-disable-next-line flowtype/require-types-at-top
export type IconType = $Keys<typeof ICONS_MAP>;

// eslint-disable-next-line flowtype/require-types-at-top
type Props = {|
    type: IconType,
    className?: string,
    onClick?: () => void
|};

const Icon = ({ type, onClick, className }: Props): React.Node => {
    const ImageIcon = ICONS_MAP[type];

    const props = {
        className : classnames('Icon', className),
        onClick   : undefined,
        role      : undefined
    };
    if (onClick) {
        props.onClick = onClick;
        props.role = 'button';
    }

    return <i {...props}><ImageIcon className="Icon__image" /></i>;
};

export default Icon;
